import { INSTANCE_URL } from "Constants";
import { isEmpty } from "ActionsSpeakers";
import {
  getRequest,
  postRequest,
  patchRequest,
  deleteRequest,
} from "NetworkCall";
import { el } from "date-fns/locale";

export var FETCH_SOCIAL = "fetch_social";
export var INSERT_SOCIAL = "insert_social";
export var OPEN_SOCIAL_MODAL = "open_social_modal";
export var LOAD_EDIT_SOCIAL_DATA = "load_social_edit_data";

export var IS_INSTAGRAM_LOADER_OPEN = "IS_INSTAGRAM_LOADER_OPEN"; // Connect with instagram

export function openSocialModal(option) {
  return {
    type: OPEN_SOCIAL_MODAL,
    payload: option,
  };
}

export function fetchSocial(session, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sociallink?filter=eventid=${session.eventid}&order=createdon%20DESC`;

  return (dispatch) => {
    getRequest(
      url,
      session,
      dispatch,
      (data) => {
        dispatch({ type: FETCH_SOCIAL, payload: data });
        callback({ success: 1 });
      },
      (error) => {
        callback({ success: 0 });
      }
    );
  };
}

export function insertSocial(session, values, social, callback) {
  var eventid = session.eventid;
  values = { ...values, eventid };

  var response;
  var url, socialJson;
  if (isEmpty(social)) {
    url = `${INSTANCE_URL}/api/v2/eventify/_table/sociallink`;
    var keys = Object.keys(values);
    var linktype = keys[0];
    values = { ...values, linktype };
    var link = values[keys[0]];
    values = { ...values, link };
    socialJson = { resource: values };
  } else {
    var sociallinkid = social.sociallinkid;
    url = `${INSTANCE_URL}/api/v2/eventify/_table/sociallink?filter=sociallinkid=${sociallinkid}`;
    var keys = Object.keys(values);
    // var link = values[keys[6]];
    var link = values[values.linktype];
    social.link = link;
    socialJson = { resource: social };
  }

  return (dispatch) => {
    var successCallback = (data) => {
      dispatch(fetchSocial(session));
      dispatch(deleteSocialFeed(session, values.linktype));
      callback({ error: 0, data: data });
    };

    var errorCallback = (error) => {
      callback({ error: 1, data: error });
    };

    if (isEmpty(social)) {
      postRequest(
        url,
        socialJson,
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    } else {
      patchRequest(
        url,
        socialJson,
        session,
        dispatch,
        successCallback,
        errorCallback
      );
    }
  };
}

export function deleteSocial(session, social, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/sociallink/${social.sociallinkid}`;
  var returnData;
  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        returnData = { error: 0, data: data };
        callback(returnData);
        dispatch(fetchSocial(session));
        dispatch(deleteSocialFeed(session, social.linktype));
      },
      (error) => {
        returnData = { error: 1, data: error };
        callback(returnData);
      }
    );
  };
}

// This function will call after any social link delete or update.
export function deleteSocialFeed(session, source, callback) {
  var filter = encodeURI(`(eventid=${session.eventid})AND(source=${source})`);
  var url = `${INSTANCE_URL}/api/v2/eventify/_table/socialfeed?filter=(${filter})`;
  var returnData;

  return (dispatch) => {
    deleteRequest(
      url,
      session,
      dispatch,
      (data) => {
        returnData = { error: 0, data: data };
        callback(returnData);
      },
      (error) => {
        returnData = { error: 1, data: error };
        callback(returnData);
      }
    );
  };
}

export function loadEditSocialData(social) {
  social = { ...social, [social.linktype]: social.link };

  return {
    type: LOAD_EDIT_SOCIAL_DATA,
    payload: social,
  };
}

export function clearLoadEditSocialData() {
  return {
    type: LOAD_EDIT_SOCIAL_DATA,
    payload: {},
  };
}

/**** Connect with instagram ****/
export function connectWithInstagram(session, body, callback) {
  var url = `${INSTANCE_URL}/api/v2/eventifyscript/connectWithInstagram`;

  return (dispatch) => {
    postRequest(
      url,
      body,
      session,
      dispatch,
      (data) => {
        if (parseInt(data.success) === 1) {
          callback({ success: 1, response: data });
        } else {
          callback({ success: 0, response: data });
        }
      },
      (error) => {
        callback({ success: 0, response: error });
      }
    );
  };
}

/*** It will show loader while instagram is connecting to its source ***/
export function openInstaLoader(isOpen) {
  return { type: IS_INSTAGRAM_LOADER_OPEN, payload: isOpen };
}
